module.exports = __webpack_public_path__ + "1_0_64/img/sign.b8c28cae.svg";